module.exports = "<p style=\"margin: 5% !important\">\r\n  Autoplay can be previewed by selecting the VR button in the top toolbar.\r\n</p>\r\n"